/* sw-clamp: progressive "Read More" for clamped copy.
   Markup: <div class="sw-clamp" style="--sw-clamp-lines:3"><div class="sw-clamp__text">…</div>
           <button class="sw-clamp__toggle" type="button" aria-expanded="false">Read more</button></div> */
(function () {
  function setup(root) {
    var text = root.querySelector('.sw-clamp__text');
    var toggle = root.querySelector('.sw-clamp__toggle');
    if (!text || !toggle) return;
    var more = toggle.getAttribute('data-more') || 'Read More';
    var less = toggle.getAttribute('data-less') || 'Read Less';

    function measure() {
      if (root.classList.contains('is-open')) return;
      var clampable = text.scrollHeight > text.clientHeight + 2;
      root.classList.toggle('is-clampable', clampable);
    }

    toggle.addEventListener('click', function () {
      var open = root.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      toggle.textContent = open ? less : more;
      if (!open) {
        root.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      }
    });

    measure();
    if ('ResizeObserver' in window) {
      new ResizeObserver(measure).observe(text);
    } else {
      window.addEventListener('resize', measure);
    }
  }

  function init(scope) {
    (scope || document).querySelectorAll('.sw-clamp:not([data-sw-clamp-ready])').forEach(function (el) {
      el.setAttribute('data-sw-clamp-ready', '');
      setup(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  window.SwClamp = { init: init };
})();
